import { db } from "@/db";
import { pollBookmark } from "@/db/schema";
import { getUserSession } from "@/lib/api/auth.api";
import { auth } from "@/lib/better-auth/auth";
import { CreateBookmarkSchema } from "@/lib/zod-schemas/create-bookmark.schema";
import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { and, eq } from "drizzle-orm";

export const createBookmark = createServerFn({
  method: "POST",
})
  .inputValidator(CreateBookmarkSchema)
  .handler(async (ctx) => {
    const request = getRequest();
    const userSession = await auth.api.getSession({ headers: request.headers });
    if (!userSession?.user) {
      throw redirect({
        to: "/sign-in",
      });
    }

    const { pollId } = ctx.data;

    const [existingBookmark] = await db
      .select()
      .from(pollBookmark)
      .where(
        and(
          eq(pollBookmark.userId, userSession.user.id),
          eq(pollBookmark.pollId, pollId)
        )
      )
      .execute();

    if (existingBookmark) {
      await db
        .delete(pollBookmark)
        .where(eq(pollBookmark.id, existingBookmark.id))
        .execute();

      return null;
    } else {
      return await db
        .insert(pollBookmark)
        .values({
          userId: userSession.user.id,
          pollId,
        })
        .returning();
    }
  });
